/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "enum.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

export enum ProfileType {
   LAWYER = 'LAWYER',
   CITIZEN = 'CITIZEN',
   PROFESSIONAL = 'PROFESSIONAL',
   STAFF = 'STAFF',
   FOREIGNER = 'FOREIGNER',
   JUSTICE = 'JUSTICE'
}


/** end of template "enum.velocity" */
